import { formatTopicsSubtopics, getComputedLanguages, getComputedCountries, getComputedPlatforms, getComputedPublications } from "../../../lib/formatFilter";

export const arrangeFilters = ({
    selectedFilters,
    refineOptions,
    widgetInfo,
    sortBy,
    custom_query,
    filterImageOptions,
    chartType,
    aggs_val,
    public_data,
    filterImageOptionsOCR,
    engagement,
    packageObj,
    dataUsage,
}) => {
    let data = {};
    data.refineOptions = refineOptions;
    data.filterImageOptions = filterImageOptions;
    data.filterImageOptionsOCR = filterImageOptionsOCR;
    if (engagement) data.exclude_engagement_types = engagement;
    if (selectedFilters?.engagement) data.exclude_engagement_types = selectedFilters?.engagement;
    if (sortBy) data.sortBy = sortBy;

    // let selectedTopics =
    //     packageObj?.package_code !== "enterprise" && selectedFilters.topics.length == 0 && selectedFilters.subtopics.length == 0
    //         ? ["ALL"]
    //         : selectedFilters.topics;
    let selectedTopics = selectedFilters?.topics;
    let selectedSubtopics = selectedFilters?.subtopics;
    // console.log("firstselectedFilters", selectedFilters, selectedTopics, dataUsage);
    // if ((dataUsage && selectedTopics?.length == 0) || selectedTopics == undefined) {
    //     if (selectedTopics == undefined) {
    //         selectedTopics = [];
    //     }
    //     selectedTopics.push("ALL");
    // }
    // console.log("firstselectedFilters", selectedFilters, selectedTopics, dataUsage);
    if (selectedTopics && selectedSubtopics) {
        let subtopicsChecked = selectedFilters.subtopics.length > 0 ? true : false;
        data.topics_data = formatTopicsSubtopics({ filter_data: { topics: selectedTopics, subtopics: selectedSubtopics } }, subtopicsChecked);
    }
    // data.topicAccount = selectedFilters.topicAccount;
    // data.name = selectedFilters.name;
    if (!dataUsage) {
        data.languages = getComputedLanguages({ languages: selectedFilters?.languages || [], public_data });
        data.countries = getComputedCountries({ countries: selectedFilters?.countries || [], public_data });
        data.platforms = getComputedPlatforms({ platforms: selectedFilters?.platforms || [], public_data });
    }
    data.publications = getComputedPublications(selectedFilters?.publications);
    data.start_date = selectedFilters?.startDateTime;
    data.end_date = selectedFilters?.endDateTime;
    data.rollingDate = selectedFilters?.rollingDate;
    data.duration = selectedFilters?.duration;

    if (selectedFilters?.scenes) {
        data.logos = selectedFilters.logos;
        data.image_analytics_types = selectedFilters.image_analytics_types;
        data.scenes = selectedFilters.scenes;
    }

    if (selectedFilters?.objects) {
        //data.logos = selectedFilters.logos;
        data.aggs == "object_overtime";
        data.image_analytics_types = selectedFilters.image_analytics_types;
        data.objects = selectedFilters.objects;
    }

    if (selectedFilters?.logos) {
        data.image_analytics_types = selectedFilters.image_analytics_types;

        data.logos = selectedFilters.logos[0] === "selectAll" ? [] : selectedFilters.logos;
        if (selectedFilters.objects) data.objects = selectedFilters.objects;
        if (selectedFilters.scenes) data.scenes = selectedFilters.scenes;
    }

    if (selectedFilters?.emotions) {
        data.emotions = selectedFilters.emotions;
    }
    let tz = JSON.parse(localStorage.company).user_timezone_name;

    if (selectedFilters?.tag_category_ids) {
        data.tag_category_ids = selectedFilters.tag_category_ids;
    }
    data.entityType = selectedFilters?.entityType;
    data.entitySubType = selectedFilters?.entitySubType;
    data.custom_query = custom_query;
    // data.groupTopics = this.props.groupTopics;
    data.extras = selectedFilters?.extras || [];
    if (selectedFilters?.post_address_country) {
        data.post_address_country = selectedFilters.post_address_country;
    }

    // To View Conversations for Clustering
    if (selectedFilters?.clustering_category) {
        data.clustering_category = selectedFilters.clustering_category;
        data.clustering_keyword = selectedFilters.clustering_keyword ? selectedFilters.clustering_keyword : "";
    }

    if (widgetInfo) {
        if (widgetInfo.api) data.aggs = widgetInfo.api;

        if (widgetInfo["aggs-interval"]) data["aggs-interval"] = aggs_val;

        if (widgetInfo.chartTypeOptions && widgetInfo.chartTypeOptions?.[chartType]?.api) data.aggs = widgetInfo.chartTypeOptions[chartType].api;

        if (widgetInfo.chartTypeOptions && widgetInfo.chartTypeOptions?.[chartType]?.["aggs-interval"]) data["aggs-interval"] = aggs_val;
    }

    if (selectedFilters?.product_attribute_categories) {
        data["product_attribute_categories"] = selectedFilters.product_attribute_categories;
        data["extraFields"] = selectedFilters.extraFields;
    }
    // if(selectedLogos.logo.length>0){

    //     data.logos=selectedLogos.logo;
    // }

    if (selectedFilters.keywordRules) {
        data.smr_rule_ids = selectedFilters.keywordRules?.[0] == "selectAll" ? [] : selectedFilters.keywordRules;
    }

    return data;
};

export const generateGuid = () => {
    let result, i, j;
    result = "";
    for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20) result = result + "-";
        i = Math.floor(Math.random() * 16).toString(16);
        result = result + i;
    }
    return result;
};

export function numberWithCommas(x) {
    if (x === null || !x) return 0; // why false was returned?

    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return parts.join(".");
}

export const mFormatter = (num) => {
    if (Math.abs(num) > 999999) {
        return Math.sign(num) * (Math.abs(num) / 1000000).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0] + "M";
    } else if (Math.abs(num) > 999) {
        return Math.sign(num) * (Math.abs(num) / 1000).toString().match(/^-?\d+(?:\.\d{0,1})?/)[0] + "K";
    } else {
        return Math.sign(num) * Math.abs(num);
    }
};
